import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Poppins', sans-serif;
    }

    html, body {
        width: 100vw;
        overflow-x: hidden;
    }

    a {
        text-decoration: none;
        color: #fff;
    }
    ::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fafafa; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #bdbdbd; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #757575; 
}
`

export default GlobalStyle;